export default __webpack_public_path__ + "static/media/thumb-NDNU-1.8e6ec74a.png";